import { getEditor, updateEditor } from '@/front/editable/state';

export const initDateCheckbox = (checkbox: HTMLInputElement) => {
  const { value: id } = checkbox;

  if (id) {
    checkbox.checked = !!getEditor(id).value;

    checkbox.addEventListener('change', async () => {
      if (checkbox.checked) {
        const date = new Date();
        date.setHours(0, 0, 0);
        await updateEditor(id, date);
      } else {
        await updateEditor(id, null);
      }
    });
  }
};
